<script setup>
defineProps({
  faq: Object,
})
</script>

<template>
  <h2 :id="faq.id">{{ faq.name }}</h2>

  <slot />
</template>
